import React from 'react';
import { motion } from 'framer-motion';
const roles = [{
  category: 'Medical',
  required: 45,
  filled: 45,
  color: 'bg-[var(--success)]'
}, {
  category: 'Course Marshals',
  required: 120,
  filled: 115,
  color: 'bg-[var(--accent)]'
}, {
  category: 'Water Stations',
  required: 150,
  filled: 140,
  color: 'bg-[var(--accent)]'
}, {
  category: 'Registration',
  required: 60,
  filled: 58,
  color: 'bg-[var(--accent)]'
}, {
  category: 'Logistics & Parking',
  required: 40,
  filled: 32,
  color: 'bg-orange-400'
}, {
  category: 'Media & VIP',
  required: 35,
  filled: 35,
  color: 'bg-[var(--success)]'
}];
export function Workforce() {
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} className="space-y-6" data-id="element-737">
      <div data-id="element-738">
        <h1 className="text-2xl font-display font-bold text-white mb-1" data-id="element-739">
          Workforce Distribution
        </h1>
        <p className="text-[var(--muted)] text-sm" data-id="element-740">
          Overview of role fulfillment across all categories.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-741">
        {roles.map((role, i) => {
        const percent = Math.round(role.filled / role.required * 100);
        return <motion.div key={role.category} initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: i * 0.1
        }} className="bg-[var(--surface)] border border-white/5 rounded-xl p-6" data-id="element-742">
              <div className="flex justify-between items-end mb-4" data-id="element-743">
                <div data-id="element-744">
                  <h3 className="text-lg font-medium text-white" data-id="element-745">
                    {role.category}
                  </h3>
                  <p className="text-[var(--muted)] text-sm" data-id="element-746">
                    {role.filled} of {role.required} filled
                  </p>
                </div>
                <span className="text-2xl font-display font-bold text-white" data-id="element-747">
                  {percent}%
                </span>
              </div>
              <div className="w-full bg-white/5 rounded-full h-2 overflow-hidden" data-id="element-748">
                <div className={`h-full rounded-full ${role.color}`} style={{
              width: `${percent}%`
            }} data-id="element-749" />
              </div>
            </motion.div>;
      })}
      </div>
    </motion.div>;
}